import { Heading, Button, Box, Grid, GridItem, Avatar, Flex,Text } from "@chakra-ui/react";
import React from "react";
import Footer from "../Components/AppBars/Footer";
import HeaderResponsive from "../Components/AppBars/HeaderResponsive";
import { collection,getDocs, orderBy } from "firebase/firestore";
import { db } from '../Configs/firebase'
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import idrDecimalHelper from "../Utils/idrDecimalHelper";


function WatchPage() {

    const navigate = useNavigate()
    const [plan, setPlan] = useState([])

    const getData = async()=>{
		const querySnapshot = await getDocs(collection(db, "tradingplan"),
		    orderBy("start", "asc")
		);
		let newArr=[]
		querySnapshot.forEach((doc) => {
            let newData =doc.data()
            newData.id=doc.id
            newArr.push(newData)
		});
        console.log(newArr, 'newArr');
        setPlan([...newArr])
	}

    useEffect(() => {
        getData()
    }, [])

    const renderItems = () => {
        return plan.map(x => (
                <GridItem w='100%'>
                    <Box borderWidth='1px' borderRadius='lg' overflow='hidden'>
                        <Box px="5" py="5">
                            <Flex justifyContent="flex-start" flexDirection="row">
                                <Box borderWidth="1" borderColor="white" bg="white" rounded="full" overflow="hidden">
                                    <Avatar name='Dan Abrahmov' src='/gain.png'/>
                                </Box>
                                <Box pl="5">
                                    <Text fontSize="md" fontWeight="semibold" textTransform="uppercase">{x.title}</Text>
                                    <Text fontSize="xs" fontWeight="normal">Timeframe 1 Jam</Text>
                                </Box>
                            </Flex>
                        </Box>
                        <Box px="5" py="5">
                            <Flex justifyContent="flex-start" flexDirection="row" flexWrap="wrap">
                                <Box width="50%">
                                    <Text fontSize="md" fontWeight="semibold" color="teal.500">{x.win_rate} %</Text>
                                    <Text fontSize="xs" fontWeight="normal">Win Rate</Text>
                                </Box>
                                <Box width="50%">
                                    <Text fontSize="md" fontWeight="semibold" color="teal.500">+{idrDecimalHelper(x.net_profit, '')}</Text>
                                    <Text fontSize="xs" fontWeight="normal">Net Profit</Text>
                                </Box>
                            </Flex>
                        </Box>
                        <Box p='5'>
                            <Flex justifyContent="space-between">
                                <Text fontWeight="semibold" fontSize="sm">{idrDecimalHelper(x.price)}</Text>
                                <Button colorScheme='teal' variant='outline' onClick={() => navigate(`/paymentglobal/tradingplan/${x.id}`)}>Beli</Button>
                            </Flex>
                        </Box>
                    </Box>
                </GridItem>
            )
        )
    }
    
  return (
    <>
      <HeaderResponsive />

      <Box maxW='8xl' m="auto">
            <Box padding='4'>
                <Heading as='h2' size={{
                    sm:'sm',
                    md:'xl'
                }} mb="2" textAlign="center">
                    Trading Plan List
                </Heading>
            </Box>

            <Box padding='4'>
                <Grid templateColumns={{md:'repeat(4, 1fr)', sm:'repeat(1, 1fr)'}} gap={6}>
                    {renderItems()}
                </Grid>
            </Box>
        </Box>
      <Footer />
    </>
  );
}

export default WatchPage;
